"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var caption = ui_blocks_1.TYPOGRAPHY.caption;
var isRemovableStyles = "\n  padding-right: 0.125rem;\n";
var isCapped = "\n  & > span:nth-child(2) {\n    max-width: 15rem;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n";
exports.Root = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: ", ";\n  padding: 0 0.75rem;\n  text-decoration: none;\n  white-space: nowrap;\n  background: transparent;\n  border-radius: ", ";\n  border: 0.0625rem solid\n    ", ";\n  color: ", ";\n\n  ", "\n  ", "\n"], ["\n  ", "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: ", ";\n  padding: 0 0.75rem;\n  text-decoration: none;\n  white-space: nowrap;\n  background: transparent;\n  border-radius: ", ";\n  border: 0.0625rem solid\n    ", ";\n  color: ", ";\n\n  ", "\n  ", "\n"])), caption, function (_a) {
  var _b;

  var theme = _a.theme;
  return (0, ui_symbols_1.calcSpace)(4, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (0, ui_symbols_1.calcSpace)(2, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["500"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["600"]', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isRemovable', isRemovableStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isCapped', isCapped);
});
var templateObject_1;